import { observer } from 'mobx-react'
import TabContent from '../../../common/TabContent'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { useEffect, useState } from 'react'
const Eco = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])
  if (!ContentState.about?.friendly.eco) return <></>
  return (
    <div className="friendly-block__eco">
      <div style={{ overflow: 'hidden' }}>
        <div
          className="friendly-block__apps-title"
          dangerouslySetInnerHTML={{
            __html: ContentState.about.friendly.eco.title,
          }}
        ></div>
      </div>
      <TabContent tab={ContentState.about.friendly.eco.tab} isActive={true} />
      <div className="friendly-block__eco-list">
        {ContentState.about.friendly.eco.list?.map((e, i) => (
          <div className="friendly-block__eco-item" key={i}>
            {e.icon && (
              <img src={e.icon} className="friendly-block__eco-icon" />
            )}
            <div className="friendly-block__eco-col">
              <div className="friendly-block__eco-title">
                {e.title}
                {width <= 600 ? '.' : ''}
              </div>
              <div className="friendly-block__eco-text">{e.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
})

export default Eco
